import { useState, useEffect } from 'react';
import { helpSendRequest, sendRequestFile } from '../helpers/helpSendRequest';
import moment from 'moment';
import { decrypt } from 'utils/utils';

export const useFetchData = () => {
  const [product, setProduct] = useState(process.env.REACT_APP_PRODUCT);
  const [tokenInfo, setTokenInfo] = useState({});
  const [returnButton, setReturnButton] = useState(true);
  const [price, setPrice] = useState('');
  const [priceToShow, setPriceToShow] = useState('');
  const [responseRequest, setResponsesRequest] = useState({ cotizacion: [], emision: [] });
  const [progressStep, setProgressStep] = useState([]);
  const [isSendForm, setIsSendForm] = useState(false);
  const [responseCotizacion, setResponseCotizacion] = useState({});
  const [folio, setFolio] = useState('');
  const [homePageData, setHomePageData] = useState({});
  const [showHomePage, setShowHomePage] = useState(true);
  const [modality, setModality] = useState("");
  const [selectedPeriodicity, setSelectedPeriodicity] = useState(12);
  const [dataForm, setDataForm] = useState({
    data: {},
    message: '',
    key: '',
    formResponses: [],
    hiddenFields: [],
    disabledFields: {},
    model: {}
  });

  const [formStatus, setFormStatus] = useState({
    steps: [],
    currentStep: 0,
    currentQuestion: 0,
    numberQuestionsStep: 0,
    isGoToBack: false
  });
  const [showFinalMessage, setShowFinalMessage] = useState({ visible: false, title: '', message: '', number: '', visibleError: false });
  const [showAlert, setShowAlert] = useState({ messagge: '', type: '' });
  const [backgroundServiceResponse, setBackgroundServiceResponse] = useState({});
  const [skipCoverages, setSkipCoverages] = useState(false);
  const [checkOption, setCheckOption] = useState('');
  const [formValues, setFormValues] = useState({});
  const [disabledOption, setDisabledOption] = useState(false);
  const [disabledButtonContinue, setDisabledButtonContinue] = useState(false);
  const [codigoPostal, setCodigoPostal] = useState(false);
  const [loadingProcedure, setLoadingProcedure] = useState(false);
  const [loadingComponent, setLoadingComponent] = useState({ visible: true, active: false });
  const [sidebarData, setSidebarData] = useState([]);
  const [activeKey, setActiveKey] = useState();
  const [insureds, setInsureds] = useState([]);
  const [checked, setChecked] = useState(false);
  const [isClassActive, setIsClassActive] = useState({ "0": false });
  const [isActive, setIsActive] = useState({});
  const [policyNumber, setPolicyNumber] = useState("000000");
  const [cleanFields, setCleanFields] = useState(true);


  useEffect(() => { product && requestInit() }, []);

  const getConfig = () => {
    return {
      host: process.env.REACT_APP_BACKEND,
      headers: { 'x-api-key': process.env.REACT_APP_API_SUBSCRIPTION_KEY },
      path: `${process.env.REACT_APP_PATH}`
    }
  }

  const getCustomRequest = async (url, headers) => {
    if (!url.toLowerCase().includes('http'))
      url = `${process.env.REACT_APP_BACKEND}${url}`

    if (!headers['x-api-key'])
      headers['x-api-key'] = process.env.REACT_APP_API_SUBSCRIPTION_KEY

    if (!headers['Authorization'])
      headers['Authorization'] = `Bearer ${await getToken()}`

    return { urlRequest: url, headerRequest: headers }
  }

  const requestInit = async (attempts = 0) => {
    const config = getConfig();
    const paths = JSON.parse(process.env.REACT_APP_PATHS);
    let initData = {};
    let errors = false;
    const newHeadersConfig = {
      ...config.headers, Authorization: `Bearer ${await getToken()}`
    }

    const responses = await Promise.all(paths.map((path) =>
      helpSendRequest(`${config.host}${config.path}${path.key}`, newHeadersConfig, path.method, {})
    )).then(res => { return res });

    responses && responses.forEach(response => {
      if (response.tipo_estado === "exito") {
        const respuesta = response.respuesta;
        initData[respuesta.key] = respuesta;
      } else if (response.errors && response.errors.length && response.errors[0].code === '401') {
        errors = true
      }
    });

    if (errors && attempts < 3) {
      attempts = attempts + 1
      localStorage.removeItem(`token_${product}`)
      await requestInit(attempts)
    }

    setDataForm({
      data: initData,
      message: 'Ok',
      key: '',
      formResponses: [],
      hiddenFields: [],
      disabledFields: {},
      model: {}
    });
  };

  const keyStatus = { W: 'cotizacion' }

  const customRequest = async (url, headers, method, body) => {
    try {
      const { urlRequest, headerRequest } = await getCustomRequest(url, headers)

      const res = await helpSendRequest(urlRequest, headerRequest, method, JSON.stringify(body));
      if (res) {
        const status = res.respuesta && res.respuesta.policy && res.respuesta.policy.policy.status;
        if (status) {
          res.fechaCreacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          setResponsesRequest(responseRequestLcl => ({
            ...responseRequestLcl, [keyStatus[status]]:
              [...responseRequestLcl[keyStatus[status]], res.respuesta && res.respuesta.policy]
          }));
        }
      }
      return res;
    } catch (error) { return error }
  };

  const fileRequest = async (url, headers, method, body) => {
    try {
      const { urlRequest, headerRequest } = await getCustomRequest(url, headers)

      return await sendRequestFile(urlRequest, headerRequest, method, body);
    } catch (error) { return error }
  };

  const validateRFC = async (info) => {
    const options = JSON.parse(process.env.REACT_APP_OPTIONS_VALIDATE_RFC);
    let initParams = `?RFC=${encodeURIComponent(info.rfc.toUpperCase())}&nombre=${encodeURIComponent(info.name.toUpperCase())}&tipoPersona=${info.type}&fechaNacimiento=${info.birthdate}`;
    const params = `${initParams}${info.type === 'personaFisica' ? `&apePaterno=${info.surname.toUpperCase()}&apeMaterno=${info.secondSurname.toUpperCase()}` : ''}`
    const res = await customRequest(`${options.url}${params}`, options.header, options.method, {});
    (!res || !res.success) && setShowAlert(res);
    return res && res.success
  }

  const getToken = async () => {
    let token = JSON.parse(localStorage.getItem(`token_${product}`));
    if (!token || (token && !token.access_token) || (token && !token.dateExpires) ||
      (token && token.dateExpires && moment().isAfter(moment(token.dateExpires)))) {

      const getTokenOptions = JSON.parse(process.env.REACT_APP_OPTIONS_GET_TOKEN);
      const res = await helpSendRequest(getTokenOptions.url, getTokenOptions.header, getTokenOptions.method, {});
      if (res && res.result) {
        const tokenEncrypted = Buffer.from(res.result, 'base64').toString('utf-8');
        const tokenDecrypt = JSON.parse(decrypt(tokenEncrypted, process.env.REACT_APP_KEY_SECRET_TOKEN));
        const dateExpires = moment().add(tokenDecrypt.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss');
        token = { ...tokenDecrypt, dateExpires };
        localStorage.setItem(`token_${product}`, JSON.stringify(token));
      }
    }
    return token && token.access_token ? token.access_token : '';
  }

  return {
    dataForm,
    formStatus,
    product,
    returnButton,
    checkOption,
    formValues,
    disabledOption,
    disabledButtonContinue,
    price,
    priceToShow,
    responseCotizacion,
    tokenInfo,
    codigoPostal,
    folio,
    selectedPeriodicity,
    showFinalMessage,
    showAlert,
    backgroundServiceResponse,
    skipCoverages,
    responseRequest,
    isSendForm,
    progressStep,
    loadingProcedure,
    homePageData,
    showHomePage,
    modality,
    loadingComponent,
    sidebarData,
    activeKey,
    insureds,
    checked,
    isClassActive,
    isActive,
    policyNumber,
    cleanFields,
    setIsClassActive,
    setChecked,
    setActiveKey,
    setSidebarData,
    setLoadingComponent,
    customRequest,
    fileRequest,
    setProduct,
    setDataForm,
    setFormStatus,
    setReturnButton,
    setCheckOption,
    setFormValues,
    setDisabledOption,
    setDisabledButtonContinue,
    setPrice,
    setPriceToShow,
    setResponseCotizacion,
    setTokenInfo,
    setCodigoPostal,
    setFolio,
    setSelectedPeriodicity,
    setShowFinalMessage,
    setShowAlert,
    setBackgroundServiceResponse,
    setSkipCoverages,
    setHomePageData,
    setShowHomePage,
    setModality,
    setIsSendForm,
    setProgressStep,
    setResponsesRequest,
    setLoadingProcedure,
    setInsureds,
    setIsActive,
    setPolicyNumber,
    validateRFC,
    setCleanFields
  };
};
